import { useMemo } from 'react';
import { citations } from '@Constants';
import Breadcrumb from '@Services/Breadcrumb';

const useSummaryAvailable = ({ activeBreadcrumb }) => {
  const rootBreadcrumb = useMemo(() => Breadcrumb.retrieveRootActiveBreadcrumb(activeBreadcrumb), [activeBreadcrumb]);

  // Check if the whole summary section is visible:
  // - summary is available in root breadcrumb
  // - if active breadcrumb context is citations,
  // - summary is not hidden for active breadcrumb
  // If not - the whole summary section should be hidden
  const isSummarySectionVisible = useMemo(
    () => rootBreadcrumb?.semanticSearchIncluded && activeBreadcrumb?.context === citations && !activeBreadcrumb?.hideSummary,
    [rootBreadcrumb, activeBreadcrumb]
  );

  // Check if summary is available for current result set:
  // - active breadcrumb is root breadcrumb, e.g. it should show only for initial search result set
  // - summary is available in active breadcrumb
  // - if active breadcrumb context is citations,
  // - summary is not hidden for active breadcrumb
  // If not - can still display summary section, but will show <SummaryNotAvailable> component inside
  const isSummaryAvailable = useMemo(
    () =>
      activeBreadcrumb?.resultName === rootBreadcrumb?.resultName &&
      activeBreadcrumb?.semanticSearchIncluded &&
      activeBreadcrumb?.context === citations &&
      !activeBreadcrumb?.hideSummary,
    [rootBreadcrumb, activeBreadcrumb]
  );

  return {
    isSummarySectionVisible,
    isSummaryAvailable,
  };
};

export default useSummaryAvailable;
